import { saveAs } from 'file-saver';
import React, { useState } from 'react';

import { Button } from '~/eds/src/components/Button/Button';
import { useIntl } from 'react-intl';
import { getDocumentOriginal } from '~/redux/api/methods/document';

import { ERROR } from '../../../types/toast.types';
import { showToast } from '../../Shared/EcToast/showToast';

function DownloadMenuButton({ documentData }) {
  const [isDownloading, setIsDownloading] = useState(false);
  const intl = useIntl();

  const handleOnDownloadOriginalClick = () => {
    if (isDownloading) return;

    setIsDownloading(true);
    const { id, document_name, file_type } = documentData;

    getDocumentOriginal(id)
      .then((res) => saveAs(res, `${document_name}${file_type}`))
      .catch(() =>
        showToast(
          ERROR,
          intl.formatMessage(
            {
              id: 'DownloadMenuButton.downloadError',
              defaultMessage:
                'Something went wrong with downloading {documentName}',
              description:
                'Error message when document download fails. Example: documentName = "contract.pdf"',
            },
            { documentName: document_name },
          ),
        ),
      )
      .finally(() => setIsDownloading(false));
  };

  return (
    <Button
      id={`document_header_downloadActions?document=${documentData.id}`}
      text={intl.formatMessage({
        id: 'DownloadMenuButton.downloadButton',
        defaultMessage: 'Download',
        description: 'Download button text',
      })}
      iconPosition="left"
      icon="download"
      onClick={handleOnDownloadOriginalClick}
      isLoading={isDownloading}
    />
  );
}

export default DownloadMenuButton;
